import { logout } from "@/api/user";
import { useMutation } from "@tanstack/react-query";

export const useLogout = () => {
  return useMutation({ mutationFn: logout });
};
